module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Bottens_(Vaud)-ec149fda7a056a145e642865b9e61370.svg";